export function shouldUseFirebaseAuth(_hostname) {
    return window.AUTH_MODE === 'firebase';
}
export function shouldRedirectToCentralAuth(_hostname) {
    return !shouldUseFirebaseAuth();
}
//# sourceMappingURL=domainRouting.js.map